export default __webpack_public_path__ + "static/media/pinred.163b14a3.svg";